// extracted by mini-css-extract-plugin
module.exports = {"PageReferralLanding":"PageReferralLanding___2LkMq","customerVoiceList":"customerVoiceList___3FNWL","emphasis":"emphasis___30B0x"};